import React from "react";
import EventDetail from "./EventDetail";

const VendorEventDetail = () => {
  return <EventDetail />;
};

export default VendorEventDetail;
